import { createSlice } from '@reduxjs/toolkit';

type regionValue = string|undefined;

export interface Region {
  top:regionValue,
  left:regionValue,
  right:regionValue,
  bottom:regionValue,
  isPercentage: boolean
};

const initialState: Region = {
  top: "0%",
  left: "0%",
  right: "100%",
  bottom: "100%",
  isPercentage: true
};

const regionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {
    changeRegion: (state, action) => {
      state = action.payload.region;
      return state;
    },
  },
});

export const { changeRegion } = regionSlice.actions;

export default regionSlice.reducer;